import { type SVGProps, useId } from "react";

export function NavRightIcon(props: SVGProps<SVGSVGElement>) {
	const titleId = useId();
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			role="img"
			aria-labelledby={titleId}
			{...props}
		>
			<title id={titleId}>Expand navigation</title>
			<path
				d="M14 12.6663V3.33301M7.33333 3.99967L11.3333 7.99967M11.3333 7.99967L7.33333 11.9997M11.3333 7.99967H2"
				stroke="#737373"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
